var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-tabs",
            { staticClass: "m-2", attrs: { pills: "", "nav-class": "m-1" } },
            [
              _c(
                "b-tab",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c(
                            "span",
                            { staticClass: "d-none d-sm-inline ml-2 mr-2" },
                            [_vm._v("계약 통계")]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [_c("ContractStatsView")],
                1
              ),
              _c(
                "b-tab",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c(
                            "span",
                            { staticClass: "d-none d-sm-inline ml-2 mr-2" },
                            [_vm._v("게시글 통계")]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [_c("ContentStatsView")],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }